export default __webpack_public_path__ + "static/phone_b.df28e30907e3fdb06df61d5dd8e7f163.svg";